import { isTransportError, useOpenWindow, useWindow } from '@krp/client-runtime'
import { skipToken } from '@reduxjs/toolkit/query'
import { CashReceiptDetailScreen, ONEC_WINDOWS, onecCashReceipt, onecProductPhotoUrl } from '@krp/resource-onec-ui'

/** Окно чека 1С по базе, виду (`sale` или `refund`) и ключу из адреса окна; при другом виде чек не читается. Товар открывает карточку 1С. */
export function CashReceiptDetailBinding() {
  const window = useWindow()
  const open = useOpenWindow()
  const resourceId = window.params.rid ?? '', kind = window.params.kind, receiptKey = window.params.key ?? ''
  const query = onecCashReceipt.useQuery(kind === 'sale' || kind === 'refund' ? { resourceId, kind, key: receiptKey } : skipToken)
  return <CashReceiptDetailScreen data={query.currentData?.data}
    error={query.isError ? isTransportError(query.error) ? query.error.message : 'Не удалось прочитать исходный чек' : null}
    openProduct={(key) => open(ONEC_WINDOWS.product, { rid: resourceId, key })} photoOf={(key) => onecProductPhotoUrl(resourceId, key)} />
}
